import { Box } from "@mui/material";
import { useMemo } from "react";

export default function Background() {
    const bubbles = useMemo(
        () =>
            [...Array(12)].map((_, i) => ({
                bottom: 150 + Math.random() * 300,
                left: Math.random() * 100,
                size: 60 + Math.random() * 40,
            })),
        []
    );

    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                background: "linear-gradient(135deg, #e0f2fe, #f8fafc)",
                overflow: "hidden",
                zIndex: -1,
            }}
        >
            {bubbles.map((bubble, i) => (
                <Box
                    key={i}
                    sx={{
                        position: "absolute",
                        bottom: `${bubble.bottom}px`,
                        left: `${bubble.left}%`,
                        width: bubble.size,
                        height: bubble.size,
                        borderRadius: "50%",
                        backgroundColor: "rgba(219,234,254,0.9)",
                    }}
                />
            ))}
        </Box>
    );
}
